import {
  fetchCreateUserReplyTemplate,
  type TCreateUserReplyTemplateResponse,
  type TCreateUserReplyTemplateRequest,
} from '../../repositories/chats/v1/create-user-reply-template';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

import type { IApplicationContext } from '../../types/applicationContext';
import type { FetchResponse } from '@cian/http-api';

const DEFAULT_ERROR_MESSAGE = 'Ошибка создания шаблона ответа';

export async function createUserReplyTemplatePublic(
  context: IApplicationContext,
  parameters: TCreateUserReplyTemplateRequest,
) {
  const { httpApi, logger } = context;

  try {
    const { response, statusCode }: FetchResponse<TCreateUserReplyTemplateResponse> =
      await fetchCreateUserReplyTemplate({
        httpApi,
        parameters,
      });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.ReplyTemplates,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response;
  } catch (e) {
    const exception = getGenericLikeError({
      error: e,
      domain: EExceptionDomain.ReplyTemplates,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/create-user-reply-template/',
      parameters: JSON.stringify(parameters),
    });

    throw exception;
  }
}
